<template>
    <div>
        <TableList v-bind="getData" @on-radio-change="checkChange"></TableList>
        <div class="text-right">
            <vButton @click="handleSelect" theme="primary">{{
                $t("global.common.update_OK", { defaultValue: "确定" })
            }}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</vButton>
        </div>
    </div>
</template>
<script>
import { HttpB2cList } from "@/service/boss/b2corder";
import TableList from "@components/templates/tablelist";
export default {
    components: {
        TableList,
    },
    methods: {
        checkChange(rows, val) {
            // console.log(rows)
            this.rows = rows;
        },
        handleSelect() {
            this.$emit("rows", this.rows);
        },
        cancel() {
            this.$emit("on-cancel");
        },
    },
    computed: {
        getData() {
            return {
                ajaxRequest: HttpB2cList,
                interceptRequest: (params) => {
                    return {
                        ...params,
                        search: {
                            ...params.search,
                            EQ_orderStatus: "picked",
                        },
                    };
                },
                startUp: true,
                Searchs: {
                    show: true,
                    style: "border:none;",
                    // labelWidth: 'auto',
                    align: "left",
                },
                SearchsData: [
                    {
                        label: this.$t("erp.b2c.search_ordernumber", {
                            defaultValue: "订单号",
                        }),
                        tag: "vInput",
                        key: "EQ_orderNo",
                        style: "width:250px",
                        show: true,
                    },
                ],
                columns: [
                    {
                        type: "selection",
                        width: 50,
                        align: "center",
                        formName: "id",
                        isRadio: true,
                    },
                    {
                        title: "ID",
                        key: "id",
                        width: 90,
                    },
                    {
                        title: this.$t("erp.b2c.search_ordernumber", {
                            defaultValue: "订单号",
                        }),
                        key: "orderNo",
                    },
                    {
                        title: this.$t("global.common.status", {
                            defaultValue: "状态",
                        }),
                        width: 90,
                        // key: 'orderStatus',
                        render: (h, { row }) => {
                            switch (row.orderStatus) {
                                case "pending":
                                    return (
                                        <vButton class="b2cspan-error span-padding">
                                            {this.$t(
                                                "erp.b2c.orderstatus_pending",
                                                { defaultValue: "未支付" }
                                            )}
                                        </vButton>
                                    );
                                    break;
                                case "unshipped":
                                    return (
                                        <vButton class="b2cspan-middle-content span-padding">
                                            {this.$t(
                                                "erp.b2c.orderstatus_unshipped",
                                                { defaultValue: "未发货" }
                                            )}
                                        </vButton>
                                    );
                                    break;
                                case "approved":
                                    return (
                                        <vButton class="b2cspan-success span-padding">
                                            {this.$t(
                                                "erp.b2c.orderstatus_approved",
                                                { defaultValue: "已审核" }
                                            )}
                                        </vButton>
                                    );
                                    break;
                                case "assigned":
                                    return (
                                        <vButton class="b2cspan-primary span-padding">
                                            {this.$t(
                                                "erp.b2c.orderstatus_assigned",
                                                { defaultValue: "已分配" }
                                            )}
                                        </vButton>
                                    );
                                    break;
                                case "picked":
                                    return (
                                        <vButton class="b2cspan-info span-padding">
                                            {this.$t(
                                                "erp.b2c.orderstatus_picked",
                                                { defaultValue: "已配货" }
                                            )}
                                        </vButton>
                                    );
                                    break;
                                case "shipped":
                                    return (
                                        <vButton class="b2cspan-light-content span-padding">
                                            {this.$t(
                                                "erp.b2c.orderstatus_shipped",
                                                { defaultValue: "已发货" }
                                            )}
                                        </vButton>
                                    );
                                    break;
                                case "canceled":
                                    return (
                                        <vButton class="b2cspan-warning span-padding">
                                            {this.$t(
                                                "erp.b2c.orderstatus_canceled",
                                                { defaultValue: "已取消" }
                                            )}
                                        </vButton>
                                    );
                                    break;
                                case "refunded":
                                    return (
                                        <vButton class="b2cspan-dark-primary span-padding">
                                            {this.$t(
                                                "erp.b2c.orderstatus_refunded",
                                                { defaultValue: "已退款" }
                                            )}
                                        </vButton>
                                    );
                                    break;
                            }
                        },
                    },
                    {
                        title: this.$t("global.common.createdtime", {
                            defaultValue: "创建时间",
                        }),
                        // key: 'channelCreated',
                        render: (h, { row }) => {
                            let arr = row.channelCreated.split("T");
                            let times = arr[1].split("+");
                            return (
                                <div>
                                    {arr[0]} {times[0]}
                                </div>
                            );
                        },
                    },
                ],
            };
        },
    },
};
</script>
